import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import debounce from "lodash/debounce";
import {
  setProductQuantity,
  updateCheckoutItemQuantity,
} from "../../../redux/slices/cartSlice";
import "./styles.css";
import { REACT_APP_URL } from "../../../config";
import { updateCartProductQuantity } from "../../../redux/slices/newCartSlice";
import { formatAmount } from "../../../utils/usefullFunction";

import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { Link } from "react-router-dom";
// import { CiDiscount1 } from "react-icons/ci";
import { IoIosSettings } from "react-icons/io";

const SingleProductCard = ({
  product,
  FinialAmount,
  setProductPrice,
  setProductUnitPrice,
  handleDeleteCartItem,
  handleMoveToWishlist,
  userdetails,
  onDiscountClick = () => {},
}) => {
  const dispatch = useDispatch();

  const [initialPrice, setInitialPrice] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState(0);
  const [cartProduct, setCartProduct] = useState(null);

  useEffect(() => {
    if (product) {
      setCartProduct(product);
    }
  }, [product]);

  useEffect(() => {
    if (cartProduct) {
      const productPrice = FinialAmount(
        cartProduct?.MRP,
        cartProduct?.singleProductId
      );

      if (cartProduct?.totalAmountAfterDiscount) {
        setPrice(
          cartProduct?.totalAmountAfterDiscount * Number(cartProduct?.quantity)
        );
      } else {
        setPrice(productPrice * Number(cartProduct?.quantity));
      }
      setInitialPrice(productPrice);
      setQuantity(cartProduct?.quantity);
    }
  }, [cartProduct, FinialAmount]);

  useEffect(() => {
    if (cartProduct) {
      setProductPrice((prevState) => ({
        ...prevState,
        [cartProduct?._id]: price,
      }));
      setProductUnitPrice((prevState) => ({
        ...prevState,
        [cartProduct?._id]: {
          unit: Math.ceil(
            FinialAmount(cartProduct?.MRP, cartProduct?.singleProductId)
          ).toFixed(0),
          discount: cartProduct?.totalAmountAfterDiscount ?? "",
        },
      }));
    }
  }, [price, setProductPrice, setProductUnitPrice, cartProduct, FinialAmount]);

  const debouncedDispatch = debounce((id, newQuantity) => {
    dispatch(
      updateCartProductQuantity({
        id,
        productData: { quantity: newQuantity },
      })
    );
  }, 500);

  const handleQuantityChange = (value) => {
    const newQuantity = Math.max(1, quantity + value);
    setQuantity(newQuantity);

    const currentPrice = cartProduct?.totalAmountAfterDiscount || initialPrice;
    const newPrice = currentPrice * newQuantity;
    setPrice(newPrice);

    if (cartProduct) {
      if (userdetails && Object.keys(userdetails).length > 0) {
        debouncedDispatch(cartProduct._id, newQuantity);
      } else {
        dispatch(
          setProductQuantity({ _id: cartProduct._id, quantity: newQuantity })
        );
      }
      dispatch(
        updateCheckoutItemQuantity({
          _id: cartProduct._id,
          quantity: newQuantity,
        })
      );
    }
  };

  const handleManualQuantityChange = (e) => {
    const value = e.target.value;
    const numericValue = parseInt(value, 10);

    if (!isNaN(numericValue) && numericValue >= 1) {
      setQuantity(numericValue);
      const currentPrice =
        cartProduct?.totalAmountAfterDiscount || initialPrice;
      const newPrice = currentPrice * numericValue;
      setPrice(newPrice);

      if (cartProduct) {
        if (userdetails && Object.keys(userdetails).length > 0) {
          debouncedDispatch(cartProduct._id, numericValue);
        } else {
          dispatch(
            setProductQuantity({ _id: cartProduct._id, quantity: numericValue })
          );
        }
      }
    } else if (value === "") {
      setQuantity(""); // allow temporary empty state while typing
    }
  };

  return (
    <tr>
      <td>
        <Link
          to={`/product/${product?.singleProductId?.Collection[0]?.url}/${product?.singleProductId?.Urlhandle}?cartId=${product?._id}`}
        >
          <img
            src={`${REACT_APP_URL}/images/product/${product?.image}`}
            alt="img25"
            style={{ height: "15vh" }}
          />
        </Link>
      </td>
      <td>
        <p
          className="m-0"
          style={{ fontSize: "18px", backgroundColor: "transparent" }}
        >
          {product?.singleProductId?.ProductName}
        </p>

        {product?.combinations?.length > 0 && (
          <div style={{ fontSize: "14px", color: "#555" }}>
            {product.combinations.map((combo, index) => (
              <div key={combo._id || index}>
                <strong>{combo.attributeId?.Name}</strong>:{" "}
                {combo.parameterId?.name}
              </div>
            ))}
          </div>
        )}

        <div
          className="btn-group"
          style={{ zoom: "70%" }}
          role="group"
          aria-label="Basic mixed styles example mx-auto"
        >
          <button
            type="button"
            className="btn btn-success"
            style={{ backgroundColor: "#475B52" }}
            onClick={() =>
              handleMoveToWishlist(cartProduct?._id, "cartSingleProducts")
            }
          >
            MOVE TO WISHLIST
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() =>
              handleDeleteCartItem(cartProduct?._id, "cartSingleProducts")
            }
          >
            REMOVE PERMANENTLY
          </button>
          <button
            type="button"
            onClick={() =>
              onDiscountClick({
                type: "singleProduct",
                productName: cartProduct?.singleProductId?.ProductName,
                _id: cartProduct?._id,
                amount: `₹${formatAmount(
                  Math.ceil(
                    FinialAmount(cartProduct?.MRP, cartProduct?.singleProductId)
                  ).toFixed(0)
                )}`,
                salePrice: Math.ceil(
                  FinialAmount(
                    cartProduct?.SalePrice,
                    cartProduct?.singleProductId
                  )
                ).toFixed(0),
                currentDiscount: cartProduct?.totalAmountAfterDiscount,
              })
            }
            className="btn btn-warning"
          >
            <IoIosSettings size={25} />
          </button>
        </div>
      </td>
      <td className="text-center">{cartProduct?.SKU || "N/A"}</td>
      <td className="text-center">
        {cartProduct?.totalAmountAfterDiscount !== 0 && (
          <>
            <strike>
              {`₹${formatAmount(
                Math.ceil(
                  FinialAmount(cartProduct?.MRP, cartProduct?.singleProductId)
                ).toFixed(0)
              )}`}
            </strike>
            &nbsp; &nbsp; ₹{formatAmount(cartProduct?.totalAmountAfterDiscount)}
          </>
        )}
        {cartProduct?.totalAmountAfterDiscount === 0 && (
          <>
            {`₹${formatAmount(
              Math.ceil(
                FinialAmount(cartProduct?.MRP, cartProduct?.singleProductId)
              ).toFixed(0)
            )}`}
          </>
        )}
        {/* &nbsp; &nbsp;
        {cartProduct?.totalAmountAfterDiscount
          ? `₹${formatAmount(cartProduct?.totalAmountAfterDiscount)}`
          : `₹${formatAmount(
              Math.ceil(
                FinialAmount(
                  cartProduct?.SalePrice,
                  cartProduct?.singleProductId
                )
              ).toFixed(0)
            )}`} */}
      </td>
      <td>
        <div className="qty" style={{ backgroundColor: "transparent" }}>
          <div className="col-lg-12">
            <div className="input-group">
              <span className="input-group-btn">
                <button
                  type="button"
                  className="quantity-left-minus btn btn-default btn-number"
                  style={{
                    backgroundColor: "#475B52",
                    userSelect: "none",
                  }}
                  data-type="minus"
                  data-field=""
                  onClick={() => handleQuantityChange(-1)}
                >
                  <FaMinus style={{ color: "#fff" }} />
                </button>
              </span>
              &nbsp;
              <input
                style={{
                  textAlign: "center",
                  maxWidth: "65px",
                  borderRadius: "5px",
                  // cursor: "default",
                  // userSelect: "none",
                }}
                type="text"
                id="quantity"
                name="quantity"
                onChange={handleManualQuantityChange}
                className="form-control input-number"
                min={1}
                value={quantity || 1}
              />
              &nbsp;
              <span className="input-group-btn">
                <button
                  type="button"
                  className="quantity-right-plus btn btn-default btn-number"
                  style={{
                    backgroundColor: "#475B52",
                    userSelect: "none",
                  }}
                  data-type="plus"
                  data-field=""
                  onClick={() => handleQuantityChange(1)}
                >
                  <FaPlus style={{ color: "#fff" }} />
                </button>
              </span>
            </div>
          </div>
        </div>
      </td>
      <td style={{ textAlign: "right", fontWeight: "600" }}>
        ₹{formatAmount(price)}
      </td>
    </tr>
  );
};

export default SingleProductCard;
